module.exports = __webpack_public_path__ + "static/future-work-home-2-f35b1e7e63178c01da285f2265ef2e7c.jpg";